import { AddBarthelScoreReport } from "app/screens/residents/show/AddBarthelScoreReport";

export default function AddBarthelScoreReportPage() {
  return <AddBarthelScoreReport />;
}
